import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { QualityScoreColumn as QualityScoreColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import qualityScoreTemplate from './quality-score.pug';

export class QualityScoreColumn extends CampaignuiBaseColumn {
  constructor({ i18n, isForVNext }) {
    const title = i18n.getString('ColumnName_QualityScore');

    super({
      ...QualityScoreColumnConfig,
      title,
      sortable: 'QualityScore/OverallQualityScore',
      type: 'string',
      helpId: 'Page_CampaignGrids_QualScore',
      bodyClasses: ['grid-column-QualityScore'],
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.titleDetail = i18n.getString('Page_Keywords_QualityScoreDetails');
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    return _.defaults({
      score: item && item.QualityScore && item.QualityScore.OverallQualityScore,
      title: this.titleDetail,
    });
  }

  template(model) {
    return qualityScoreTemplate(_.extend({
      isForVNext: this.isForVNext,
    }, model));
  }
}
